import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlarmsApiService} from '../../../services/api/alarms/alarms-api.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {DateTimePipe} from '../../../pipes/date-time/date-time.pipe';
import * as _ from 'lodash';
import {PageEventCursorInf} from '../../../classes/common/table/page-event-cursor';
import {
  TableColumnsConfigurationDialogComponent
} from '../../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AlarmsSearchComponent} from '../alarms-search/alarms-search.component';
import {AlarmSeverityTablePipe} from '../../pipes/alarm-severity-table.pipe';
import {interval} from 'rxjs';
import {SearchTermDefinitionInf} from '../../../interfaces/common/search/search-term-definition-inf';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import Search from '../../../utils/search';

@Component({
  selector: 'alarms',
  templateUrl: './alarms-table.component.html',
  styleUrls: ['./alarms-table.component.scss']
})
export class AlarmsTableComponent implements OnInit, OnDestroy {

  @ViewChild(ArmTableComponent) armTable;
  @Input() type;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'alarmSeverity', display: 'Severity', selected: true, transformer: AlarmSeverityTablePipe, width: 50},
    {name: 'alarmDateAndTime', display: 'Date And Time', selected: true, transformer: DateTimePipe, width: 100},
    {name: 'name', display: 'Name', selected: true, width: 150},
    {name: 'alarmSource', display: 'Alarm Source', selected: true, width: 200},
    {name: 'alarmTextualDescription', display: 'Description', selected: true, width: 200},
  ];

  data;
  pageEventCursor: any;
  isUnauthorized: boolean;
  search: any = {};
  selection: any = [];
  alarmsSearchComponent = AlarmsSearchComponent;

  searchData: any;
   severityOptions = [
    {value: 'cleared', text: 'Clear'},
    {value: 'indeterminate', text: 'Indeterminate'},
    {value: 'warning', text: 'Warning'},
    {value: 'minor', text: 'Minor'},
    {value: 'major', text: 'Major'},
    {value: 'critical', text: 'Critical'}
  ];

   acknowledgedOptions = [
    {value: 0, text: 'False'},
    {value: 1, text: 'True'}
  ];
  searchTerms: SearchTermDefinitionInf[] = [
    {term: 'name', operator: ':', displayName: 'Name'},
    {term: 'severity', operator: '=', displayName: 'Severity', displayValue: Search.getOptionValue(this.severityOptions)},
    {term: 'source', operator: ':', displayName: 'Source'},
    {term: 'description', operator: ':', displayName: 'Description'},
    {term: 'additionalInfo', operator: ':', displayName: 'Additional Info'},
    {term: 'startDate', operator: '=', displayName: 'Start Date', displayValue: (date) => new DateTimePipe().transform(date)},
    {term: 'endDate', operator: '=', displayName: 'End Date', displayValue: (date) => new DateTimePipe().transform(date)},
    {term: 'operator', operator: ':', displayName: 'Operator'},
    {term: 'value', operator: ':', displayName: 'Value'},
    {term: 'action', operator: ':', displayName: 'Action'},
    {term: 'isAcknowledged', operator: '=', displayName: 'Acknowledged', displayValue: Search.getOptionValue(this.acknowledgedOptions)},
  ];

  isAutoRefreshActivated = true;
  private refreshObservable;
  private readonly TABLE_REFRESH_TIME = 30000;
  summaryTitle: string;

  constructor(private alarmsApiService: AlarmsApiService,
              private userPrivilege: UserPrivilegeService,
              public dialog: MatDialog,
              private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.startRefreshObservable();
    this.isUnauthorized = !this.userPrivilege.isAuthorized();

    this.pageEventCursor = {
      before: null,
      after: null,
      pageSize: 25
    };

    this.summaryTitle = this.type === 'history' ? 'HISTORY ALARMS SUMMARY' : 'ALARMS SUMMARY';
    this.setSearchData();
    this.refresh();
  }


  ngOnDestroy(): void {
    this.unsubscribeRefreshObservable();
  }

  acknowledgeAlarm(): void {
    let selectedAlarmsId: number[];

    selectedAlarmsId = this.selection.map((alarm) => {
      return alarm.id;
    });

    this.alarmsApiService.editActiveAlarmsAsAcknowledge(selectedAlarmsId).subscribe((data) => {
      this.refresh();
    });
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '450px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  pageChanged(event: PageEventCursorInf): void {
    this.pageEventCursor = event;
    this.refresh();
  }

  refresh( keepPage?: boolean): void {
    if (keepPage) {
      this.pageEventCursor.direction = this.pageEventCursor.currentPageDirection;
      this.pageEventCursor.after = this.pageEventCursor.currentPageAfter;
      this.pageEventCursor.before = this.pageEventCursor.currentPageBefore;
    }

    let params = {
      limit: this.pageEventCursor.pageSize,
      cursor: _.isNil(this.pageEventCursor.after) ? null : this.pageEventCursor
    };

    params = {...this.search, ...params};
    this.loaderService.showMainContainer();

    if (this.type === 'active'){
      this.alarmsApiService.getActiveAlarms(params).toPromise().then(data => {
        this.setData(data);
        this.loaderService.hideMainContainer();
      }).catch(err => {
        console.log(`Exception was thrown in refresh ${err}`);
        this.loaderService.hideMainContainer();
      });

    } else{
      this.alarmsApiService.getHistoryAlarms(params).toPromise().then(data => {
        this.setData(data);
        this.loaderService.hideMainContainer();
      }).catch(err => {
        console.log(`Exception was thrown in refresh ${err}`);
        this.loaderService.hideMainContainer();
      });

    }
  }

  setData(data: any): void {
    this.data = data.alarms;
    this.pageEventCursor.before = data.cursor.before;
    this.pageEventCursor.after = data.cursor.after;
  }

  toggleAutoRefresh(): void {
    this.isAutoRefreshActivated = !this.isAutoRefreshActivated;

    this.isAutoRefreshActivated ? this.startRefreshObservable() : this.refreshObservable.unsubscribe();
  }

  private startRefreshObservable(): void {
    this.unsubscribeRefreshObservable();

    this.refreshObservable = interval(this.TABLE_REFRESH_TIME).subscribe(() => this.refresh(true));
  }

  private unsubscribeRefreshObservable(): void {
    if (this.refreshObservable) {
      this.refreshObservable.unsubscribe();
    }
  }

  generateAutoRefreshName(): string {
    return `${this.isAutoRefreshActivated ? 'Stop' : 'Start'} Auto Refresh`;
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.search = data;

    this.refresh();
  }

  setSearchData(): void {

    this.searchData = {
      type: this.type,
      severityOptions: this.severityOptions,
      acknowledgedOptions: this.acknowledgedOptions
    };
  }

}
